<template>
  <div class="tool-card">
    <div class="card-header">
      <span class="card-title">{{ title }}</span>
      <el-tag :type="tagType" v-if="tagText">{{ tagText }}</el-tag>
    </div>
    <p class="card-desc">{{ description }}</p>
    <div class="card-footer">
      <template v-if="buttons.length">
        <el-button
          v-for="(btn, index) in buttons"
          :key="index"
          v-show="btn.show"
          :type="btn.type"
          @click="btn.handler"
        >
          {{ btn.text }}
        </el-button>
      </template>
    </div>
    <img class="card-icon" :src="iconSrc" :alt="title">
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps(
  {
    title: { type: String, required: true },
    tagType: { type: String, default: '' },
    tagText: { type: String, required: true, default: '' },
    description: { type: String, required: true },
    iconSrc: { type: String, required: true },
    buttons: {
      type: Array,
      default: () => [],
      validator: (value) => { return value.every((btn) => typeof btn.text === 'string' && typeof btn.handler === 'function') } },
  },
)

const { title, tagType, tagText, description, iconSrc, buttons } = toRefs(props)
</script>

<style scoped>
.tool-card {
    width: 100%;
    border: 1px solid #E7E8EB;
    border-radius: 8px;
    padding: 16px;
    position: relative;
    .card-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        color: rgba(0, 0, 0, 0.9);
    }
    .card-desc {
        font-size: 14px;
        margin: 8px 0 20px 0;
    }
    .card-icon {
        width: 40px;
        position: absolute;
        right: 16px;
        bottom: 3px;
    }
  }
</style>
